module.exports = __webpack_public_path__ + "static/media/logo.6ac6746e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 710
// module chunks = 37